import React, { useEffect, useState } from "react"
import { confirmSignIn } from "aws-amplify/auth"
import { LoginInput } from "../login-input"
import { LoginButton } from "../login-button"
import errorIcon from '../../../assets/img/error-icon.svg'

interface TotpCodeProps {
    setNextStep: React.Dispatch<any>
}


export const TotpCode: React.FC<TotpCodeProps> = ({ setNextStep }) => {
    const [mfaCode, setMfaCode] = useState<string>('')
    const [isCredentailsError, setIsCredentialsError] = useState(false)

    useEffect(() => {
        return () => {
            setMfaCode('')
        }
    }, [])

    const mfaCodeValidation = (code: string) => {        
        const regex = /^\d{6}$/
        return regex.test(code)
    }

    useEffect(() => {
        setIsCredentialsError(false)
    }, [mfaCode])

    const onFormSubmit = async (ev: React.FormEvent) => {
        ev.preventDefault()
        if (!mfaCodeValidation(mfaCode)) return

        try {
            const resTotpCode = await confirmSignIn({ challengeResponse: mfaCode })
            setNextStep(resTotpCode.nextStep)
        } catch (e) {
            console.error('error', e)
            setIsCredentialsError(true)
        }
    }

    return (<>
        <form onSubmit={onFormSubmit} className="totp-code password-login-container">
            <LoginInput
                type="text"
                inputValue={mfaCode}
                onSetInput={setMfaCode}
                validationFunc={mfaCodeValidation}
                placeholder="MFA code"
                invalidMsg="Invalid code. Should be 6 digits"
            />
            <div className="login-btn-container">
                <LoginButton txt="log in" action={() => null} isFullColor={true} />

                {isCredentailsError && (
                    <div className="credentials-error-msg">
                        <img src={errorIcon} alt="error" />
                        <p>Wrong code</p>
                    </div>
                )}
            </div>
        </form>
    </>
    );
};
